/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecurityGroupRoleAssignmentsReadModel } from './SecurityGroupRoleAssignmentsReadModel';
import {
    SecurityGroupRoleAssignmentsReadModelFromJSON,
    SecurityGroupRoleAssignmentsReadModelFromJSONTyped,
    SecurityGroupRoleAssignmentsReadModelToJSON,
    SecurityGroupRoleAssignmentsReadModelToJSONTyped,
} from './SecurityGroupRoleAssignmentsReadModel';

/**
 * 
 * @export
 * @interface SecurityGroupRoleAssignmentsReadModelPagedList
 */
export interface SecurityGroupRoleAssignmentsReadModelPagedList {
    /**
     * 
     * @type {number}
     * @memberof SecurityGroupRoleAssignmentsReadModelPagedList
     */
    readonly totalCount: number;
    /**
     * 
     * @type {Array<SecurityGroupRoleAssignmentsReadModel>}
     * @memberof SecurityGroupRoleAssignmentsReadModelPagedList
     */
    readonly entities: Array<SecurityGroupRoleAssignmentsReadModel>;
}

/**
 * Check if a given object implements the SecurityGroupRoleAssignmentsReadModelPagedList interface.
 */
export function instanceOfSecurityGroupRoleAssignmentsReadModelPagedList(value: object): value is SecurityGroupRoleAssignmentsReadModelPagedList {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    return true;
}

export function SecurityGroupRoleAssignmentsReadModelPagedListFromJSON(json: any): SecurityGroupRoleAssignmentsReadModelPagedList {
    return SecurityGroupRoleAssignmentsReadModelPagedListFromJSONTyped(json, false);
}

export function SecurityGroupRoleAssignmentsReadModelPagedListFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityGroupRoleAssignmentsReadModelPagedList {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'entities': ((json['entities'] as Array<any>).map(SecurityGroupRoleAssignmentsReadModelFromJSON)),
    };
}

export function SecurityGroupRoleAssignmentsReadModelPagedListToJSON(json: any): SecurityGroupRoleAssignmentsReadModelPagedList {
    return SecurityGroupRoleAssignmentsReadModelPagedListToJSONTyped(json, false);
}

export function SecurityGroupRoleAssignmentsReadModelPagedListToJSONTyped(value?: Omit<SecurityGroupRoleAssignmentsReadModelPagedList, 'totalCount'|'entities'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

